// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PharmacyModel } from './pharmacyModel.js';
import type { PharmacyPointOfContactModel } from './pharmacyPointOfContactModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountGetCaseGetCasePharmacyResponseModel {
    'pharmacyData': PharmacyModel | null;
    'pointOfContactData': Array<PharmacyPointOfContactModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountGetCaseGetCasePharmacyResponseModel>> = [
        {
            "name":     "pharmacyData",
            "baseName": "pharmacyData",
            "type":     "PharmacyModel"
        },
        {
            "name":     "pointOfContactData",
            "baseName": "pointOfContactData",
            "type":     "Array<PharmacyPointOfContactModel>"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountGetCaseGetCasePharmacyResponseModel.attributeTypeMap;
    }
}
